import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ParentalPinDialDownContainer = styled.div<Props>`
  bottom: ${-60 * Screen.widthRatio}px;
  position: absolute;
`;

export default ParentalPinDialDownContainer;
